export const getUiConfigFilename = (configName: string) => `${configName}-ui-config.json`;
